import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ape_cart")) || []; } catch { return []; }
  });
  const [promo, setPromoState] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ape_promo")) || null; } catch { return null; }
  });

  useEffect(() => { localStorage.setItem("ape_cart", JSON.stringify(items)); }, [items]);
  useEffect(() => { localStorage.setItem("ape_promo", JSON.stringify(promo)); }, [promo]);

  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem("ape_ref", ref.trim().toUpperCase());
  }, []);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.slug === product.slug);
      if (found) return prev.map((i) => i.slug === product.slug ? { ...i, qty: i.qty + qty } : i);
      return [...prev, { slug: product.slug, name: product.name, price: product.price, accent: product.accent, dosage: product.dosage, qty }];
    });
  };
  const removeItem = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const setQty = (slug, qty) => setItems((prev) => prev.map((i) => i.slug === slug ? { ...i, qty: Math.max(1, qty) } : i));
  const clear = () => { setItems([]); setPromoState(null); };
  const setPromo = (p) => setPromoState(p);
  const clearPromo = () => setPromoState(null);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const percentOff = promo ? promo.percent_off : 0;
  const discount = +(subtotal * percentOff / 100).toFixed(2);
  const total = +(subtotal - discount).toFixed(2);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, setQty, clear, count, subtotal, discount, total, promo, setPromo, clearPromo }}>
      {children}
    </CartContext.Provider>
  );
}
